import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../const/config";
import api from "../axios";

const SignupPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/auth/signup/", {
        username,
        email,
        password,
      });

      localStorage.setItem(`${API_BASE_URL}_token`, response.data.access_token); // Store JWT token
      navigate("/"); // Redirect to a protected route
    } catch (err: any) {
      const message = err.response?.data?.detail || err.message || "Signup failed";
      setError(message);
    }
  };

  return (
    <div className="container mx-auto my-10 p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-bold mb-4">Sign Up</h1>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSignup}>
        <div className="mb-4">
          <label className="block">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full p-2 border"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border"
            required
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2">
          Sign Up
        </button>
      </form>

      {/* Button to navigate to Login page */}
      <div className="mt-4">
        <p>Already have an account?</p>
        <button
          onClick={() => navigate("/login")}
          className="text-blue-500 underline"
        >
          Login here
        </button>
      </div>
    </div>
  );
};

export default SignupPage;
